import ellipseBlueIcon from "../../../assets/img/icons/ellipse-blue.svg";
import {formatDateFrom} from "../../../utils";

const NotificationDate = ({date}) => {

    return (
        <div className="notification-card__date"><img src={ellipseBlueIcon} alt=""/>{formatDateFrom(date)}</div>
    )
}
export default NotificationDate;